import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const softwareUpdate = z.object({
  status: z.enum(['up-to-date', 'update-available']),
  latest: z.string(),
  download: z
    .object({
      url: z.string(),
      hash: z.string(),
    })
    .optional(),
});

export class SoftwareUpdate extends createZodDto(softwareUpdate) {}
